"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function DownPage() {
    return ((0, jsx_runtime_1.jsx)("div", { className: "declined-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "content", children: [(0, jsx_runtime_1.jsx)("h1", { className: "first-title", children: "Service Interruption" }), (0, jsx_runtime_1.jsx)("p", { children: "We are currently experiencing a service outage. We apologize for the inconvenience. Please check again in a few minutes to see if we are back." })] }) }));
}
exports.default = DownPage;
